if (!customElements.get('roomix-items-filter')) {
  customElements.define('roomix-items-filter',
    class roomixItemsFilter extends HTMLElement {
    constructor() {
      super();
      this.selectedFilter = this.querySelector('.selected-filter');
      this.selectItems = this.querySelectorAll('li a');
      this.filterbyValue = this.selectItems[0].dataset.filter;
      this.selectItems.forEach(item => {
        item.addEventListener('click', this.onFilterClick.bind(this));
      });
      this.sliderComponent = this.parentElement.querySelector('slider-component');
      this.itemsToFilter = this.parentElement.querySelectorAll('slider-component li');

    }
    connectedCallback() {
      this.displayFilteredItems();
    }
    onFilterClick = (e) => {
      e.preventDefault();
      this.selectItems.forEach(item => {
        item.classList.remove('selected');
      });
      let element = e.target;
      if (element.tagName !== 'A') {
        element = element.closest('a');
      }
      element.classList.add('selected');
      this.filterbyValue = element.dataset.filter;
      this.replaceFilterMainItem(element);
      this.displayFilteredItems();
    }

    replaceFilterMainItem = (filterElement) => {
      this.selectedFilter.innerHTML = filterElement.innerHTML;
      this.querySelector('details').removeAttribute('open');
    }

    displayFilteredItems = () => {
      this.itemsToFilter.forEach(item => {
        if (item.dataset.filter === this.filterbyValue || item.dataset.filter.includes(this.filterbyValue)) {
          item.classList.remove('hidden');
        } else {
          if (item.dataset.alwaysVisible !== 'true') {
            item.classList.add('hidden');
          }
        }
      });
      this.sliderComponent.initPages()
    }

  });
}